import { httpGetAndParse } from '../../../utils/fetchService';

export const fetchCalcStatus = globalContext =>
  httpGetAndParse({
    route: `/api/shared/${globalContext.apiRouteParamString}/calc-status`,
    errorMessage: 'Fetching calc status failed',
  });
